import React, { useState, useRef } from 'react';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Form, Input, Row, Space, message, Switch, Select, InputNumber } from 'antd';
import { getList as getListAreas } from '../../../../apis/AreasTrabajoApi';
import { insert, update, getById } from '../../../../apis/EstacionChequeoApi';
import { getList as getAllAnalitica } from '../../../../apis/OdooAnaliticaApi';
import './Edit.scss';

const { Option } = Select;

const App = ({ title, id, open, finish }) => {
    const [form] = Form.useForm()
    const [ID, setID] = useState(id);
    const [initialValues, setInitialValues] = useState(null);
    const [disabled, setDisabled] = useState(false);
    
    // Catálogos
    const [areas, setAreas] = useState([]);
    const [analiticas, setAnaliticas] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);

    const handleOk = async () => {
        try {
            const fields = await form.validateFields();
            let success = false;
            
            const payload = {
                ...fields,
                principal: fields.principal || false
            };

            if (ID > 0) {
                //Update
                payload.id = ID;
                const response = await update(payload);
                success = response.ok;
                if (response.ok) {
                    message.success('Se actualizó correctamente la estación!');
                }
            } else {
                //Create
                const response = await insert(payload);
                success = response.ok;
                if (response.ok) {
                    setID(response.payload);
                    message.success('Se guardó correctamente la estación!');
                }
            }

            if (success) {
                finish(true, false);
            }
        } catch (errorInfo) {
            message.error('Por favor completa todos los campos obligatorios.');
        }
    }

    const getCatalogs = async () => {
        // Obtener áreas
        const responseAreas = await getListAreas();
        if (responseAreas.ok) {
            let areasItems = responseAreas.payload.map(item => ({
                value: item.value,
                text: item.text,
                id: item.value
            }));
            setAreas(areasItems);
        }

        // Obtener analíticas
        const responseAnaliticas = await getAllAnalitica();
        if (responseAnaliticas.ok) {
            let analiticasItems = responseAnaliticas.payload.map(item => ({
                value: item.id,
                text: item.name,
                id: item.id
            }));
            setAnaliticas(analiticasItems);
        }

        // Datos harcodeados para departamentos
        setDepartamentos([
            { value: 1, text: 'Producción' },
            { value: 2, text: 'Calidad' },
            { value: 3, text: 'Mantenimiento' },
            { value: 4, text: 'Recursos Humanos' }
        ]);
    }

    const onClose = () => {
        finish(false);
        setInitialValues(null);
    }

    const effectRan = useRef(false);
    React.useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();
                if (ID > 0) {
                    await refreshData();
                } else {
                    setInitialValues({
                        nombre: '',
                        principal: false,
                        num_reloj: null,
                        area_id: null,
                        analitica_id: null,
                        departamento: null
                    });
                }
            })();
        }
        return () => effectRan.current = true;
    }, [ID]);

    const refreshData = async () => {
        const response = await getById(ID);
        if (response.ok) {
            let item = response.payload;
            setInitialValues({
                nombre: item.nombre,
                principal: item.principal,
                num_reloj: item.num_reloj,
                area_id: item.area?.id || null,
                analitica_id: item.analitica?.id || null,
                departamento: item.departamento
            });
        }
    }

    return (
        <Drawer
            title={<>
                {ID > 0 ? '(' + ID + ') ' : ''}
                {title}
            </>}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            width={600}
            styles={{
                body: {
                    paddingBottom: 80,
                },
            }}
            extra={[
                <Space key="actions">
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                        Guardar
                    </Button>
                </Space>
            ]}
        >
            {
                initialValues &&
                <Form layout="vertical" disabled={disabled}
                    form={form} requiredMark initialValues={initialValues} onFinish={handleOk} >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="nombre"
                                label="Nombre"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega el nombre',
                                    },
                                ]}>
                                <Input placeholder="Por favor agrega el nombre" />
                            </Form.Item>
                        </Col>
                        
                        <Col span={24}>
                            <Form.Item
                                name="num_reloj"
                                label="Número de Reloj"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un número',
                                    },
                                ]}>
                                <InputNumber placeholder="Por favor agrega un número" style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        
                        <Col span={24}>
                            <Form.Item
                                name="area_id"
                                label="Área"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecciona un área',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Por favor selecciona un área"
                                    showSearch
                                    optionFilterProp="children"
                                >
                                    {
                                        areas.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        
                        <Col span={24}>
                            <Form.Item
                                name="analitica_id"
                                label="Analítica"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecciona una analítica',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Por favor selecciona una analítica"
                                    showSearch
                                    optionFilterProp="children"
                                >
                                    {
                                        analiticas.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        
                        <Col span={24}>
                            <Form.Item
                                name="departamento"
                                label="Departamento"
                            >
                                <Select
                                    placeholder="Por favor selecciona un departamento"
                                    showSearch
                                    optionFilterProp="children"
                                >
                                    {
                                        departamentos.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        
                        <Col span={24}>
                            <Form.Item
                                name="principal"
                                label="Principal"
                                valuePropName="checked"
                            >
                                <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            }
        </Drawer>
    );
};
export default App;